import styled from 'react-emotion'

const SectionIntro = styled.div`
  margin-bottom: 7rem;
`

export default SectionIntro



// WEBPACK FOOTER //
// ./src/routes/home/components/SectionIntro.js